import { useEffect } from "react"
import nookies from "nookies"

import { GoogleInitializeResponse, IGoogleEndPointResponse } from "@interfaces/google"
import AuthServices from "@lib/api/services/auth.services"
import { decodeJwt } from "@lib/functions/jwt"
import { loadScript, onFirstInteraction } from "@lib/functions/third-party"

export function useGoogleOneTapLogin() {
  useEffect(() => {
    if (nookies.get({}).HSTOKENID) {
      return
    }

    const handleInitialize = async (data: GoogleInitializeResponse) => {
      const decode = decodeJwt<IGoogleEndPointResponse>(data.credential)
      if (!decode) {
        return
      }

      const res = await new AuthServices().googleLogin({
        email: decode.email,
        fullName: decode.name,
        googleId: decode.sub,
      })

      if (res && res.isSuccess) {
        const result = res.getValue()

        if (result.new_user === 0) {
          window.location.reload()
        } else {
          window.location.href = "/biodata"
        }
      }
    }

    return onFirstInteraction(() =>
      loadScript("https://accounts.google.com/gsi/client", () => {
        window.google?.accounts?.id?.initialize({
          client_id: process.env.GOOGLE_CLIENT_ID || process.env.HARISENIN_GOOGLE_CLIENT_ID || "",
          callback: handleInitialize,
        })
        window.google?.accounts?.id?.prompt()
      })
    )
  }, [])
}
